<div class="bot">
  <div class="block block_first">
    <div class="bot__photo">
      <tui-avatar
        [src]="chat && chat.title ? chat.title : ('' | tuiInitials)"
        [style.background]="chat && chat.title ? chat.title : ('' | tuiAutoColor)"
        [size]="'l'"
        [round]="true"
      ></tui-avatar>
    </div>

    <div class="bot__name">{{ chat?.title }}</div>

    <div class="bot__status">{{ this.botStatus }}</div>
  </div>

  <div *ngIf="organisation" class="block block_info">
    <tui-data-list>
      <button tuiOption class="organisation" [routerLink]="'/organisation/' + organisation.organisationId">
        <app-icon class="organisation__icon" [src]="'building-2'" size="24px"></app-icon>

        <span class="organisation__title">
          {{ organisation.organisationName }}
        </span>
      </button>
    </tui-data-list>
  </div>

  <div class="block block_info">
    <tui-data-list>
      <button tuiOption class="notifications" (click)="onChangeNotificationsToggleValue()">
        <app-toggle [ngModel]="!!chat && chat.notificationSettings.muteFor === 0" [size]="'m'"></app-toggle>

        <span class="notifications__title">
          {{ 'common.labels.notifications' | translate }}
        </span>
      </button>
    </tui-data-list>
  </div>
</div>
